import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import wCls from 'Flow2/components/UI/Overlay/InputWindow.module.scss';

import Button from 'Flow2/components/UI/Button/Button';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import InputWindow from 'Flow2/components/UI/Overlay/InputWindow';
import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';

import PH from 'Flow2/util/MetadataPermissionHelper.js';
import SM from 'Flow2/util/StructureMapping.js';
import MEH from 'Flow2/util/MetadataElementHelper.js';
import { dateFormat } from 'Flow2/util/helperFunctions.js';

import * as actions from 'store/actions/index';

import classes from './InputWindow.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';

import StructureMapping from 'Flow2/util/StructureMapping.js';

const _FLOW_WINDOW_HELP_ = "_FLOW_WINDOW_HELP_";

class HelpWindow extends Component {
    constructor(props) {
        super(props);
        this.state = HelpWindow.initState(props);
    }
    
    static initState(props) {
        const state = {}; 
        return state;
    }
	
	static getDerivedStateFromProps(props, state) {
        return null;
    }
    
    componentDidMount() {}
    
    componentDidUpdate(prevProps, prevState) {}
    
    componentWillUnmount() {}
    
    onSave = () => {
        this.props.onClose();
    }
    
    renderMessage = (id) => {
        if(id.indexOf("head") !== -1) {
            return (
                <FormattedMessage id={id} defaultMessage={"Head"}>{(msg) => <h4>{msg}</h4>}</FormattedMessage>
            );
        } 
        return (
            <FormattedMessage id={id} defaultMessage={"Text"} >{(msg) => <p>{msg}</p>}</FormattedMessage>
        );
    }

    renderContent = () => {
        const output = [];
        const content = typeof(this.props.content) === 'string' ? [ this.props.content ] : this.props.content;
        
        if(Array.isArray(content)) {
            content.forEach(id =>{
                if(typeof(id) === 'string') {
                    output.push(this.renderMessage(id));
                }
            });
        }
        
        return (
            <div className={[classes.WindowContent, classes.HelpContent, "fullWidth"].join(' ')}>
                { output }
            </div>
        )
    }

    render() {
        return(
			<InputWindow 
                show={this.props.show} 
                content={this.renderContent()}
                title={this.props.intl.formatMessage({ id: "common.help" })}
                onSave={this.onSave}/>
        )
    }
}

class Help extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            show: false
        }
    }
    
    onShow = () => {
        this.props.setWindow(_FLOW_WINDOW_HELP_, this.renderWindow());
        this.setState({ show: true }); 
    }
    
    onClose = () => {
        this.props.removeWindow(_FLOW_WINDOW_HELP_);
        this.setState({ show: false });
    }
    
    renderWindow = () => {
        return (
            <HelpWindow
                {...this.props}
                show={true}
                onClose={this.onClose}
            />
        );
    }
    
    render() {
        if(this.props.mode !== Metadata.METADATA_MODE_EDIT) return "";
        //if(!StructureMapping.hasHelp(this.props.elm.obj)) return "";
        if(!this.props.content) return "";
    
        return (
            <span
                onClick={this.onShow}
                className={[wCls.Help].join(' ')} 
                data-tooltip={this.props.intl.formatMessage({ id: "common.help", defaultMessage: "Help" })}>
                    <FontAwesomeIcon icon={faQuestionCircle} />
            </span>
        );
    }
};

const mapStateToProps = (state) => {
	return {
        
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setWindow: (id, elm) => dispatch(actions.setWindow(id, elm)),
		removeWindow: (id, elm) => dispatch(actions.removeWindow(id))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Help));
